import { Component, OnInit } from '@angular/core';
import { Card, CardModule } from '@spartacus/storefront';
import { QuoteDetails, QuoteDetailsRequest } from '../../../../../core/models/quotes.model';
import { ActivatedRoute } from '@angular/router';
import { I18nModule, RoutingService, TranslationService } from '@spartacus/core';
import { PageTitle } from '../../../store-front/misc/page-title/page-title.component';
import { QuoteDetailsProductTableComponent } from './quote-history-product-table/quote-details-product-table.component';
import { QuotesService } from '../../core/quotes.service';
import { BehaviorSubject, take } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { ToasterService } from '../../../../../components/toaster/toaster.service';
import { initialStatus, loadingStatus } from '../../../../../core/models/request-status.model';
import { LocalLoaderComponent } from '../../../../../components/loader/local-loader/local-loader.component';
import { TOASTER_TYPE } from '../../../../../components/toaster/toaster.model';

@Component({
  selector: 'quotes-history-details',
  standalone: true,
  imports: [CardModule, QuoteDetailsProductTableComponent, CommonModule, I18nModule, LocalLoaderComponent, PageTitle],
  templateUrl: './quotes-history-details.component.html',
  styleUrl: './quotes-history-details.component.scss',
  providers: [ActiveCartService],
})
export class QuotesHistoryDetailsComponent implements OnInit {
  quoteId: string | null = null;
  quoteDetails$ = new BehaviorSubject<QuoteDetailsRequest>(initialStatus);

  constructor(
    private route: ActivatedRoute,
    protected translation: TranslationService,
    protected quoteService: QuotesService,
    protected cartService: ActiveCartService,
    protected toasterService: ToasterService,
    protected routingService: RoutingService,
  ) {}

  ngOnInit(): void {
    this.getQuoteDetails();
    this.handleActiveCart();
  }

  transformQuoteIntoCard(quote: QuoteDetails): Card {
    const paragraphs = [
      quote.quoteName ? { title: 'Quote Name', text: [quote.quoteName] } : null,
      quote.quoteStatus ? { title: 'Status', text: [quote.quoteStatus] } : null,
      quote.endCustomer ? { title: 'Final Customer', text: [quote.endCustomer] } : null,
      quote.location ? { title: 'Location', text: [quote.location] } : null,
      quote.effectiveDate ? { title: 'Quote Date', text: [quote.effectiveDate] } : null,
      quote.expirationDate ? { title: 'Quote Expiration Date', text: [quote.expirationDate] } : null,
      quote.createdBy ? { title: 'Requested By', text: [quote.createdBy] } : null,
    ].filter(item => item !== null);

    return {
      header: 'Quote# ' + quote.quoteNumber,
      paragraphs,
    };
  }

  getQuoteDetails() {
    this.route.queryParamMap.subscribe(params => {
      this.quoteId = params.get('id');
      if (this.quoteId) {
        this.quoteDetails$.next(loadingStatus);

        setTimeout(() => {
          this.quoteService
            .getQuoteDetails(this.quoteId!)
            .pipe(take(1))
            .subscribe(response => {
              if (response.message) {
                this.toasterService.closeALL();

                this.toasterService.init({
                  type: TOASTER_TYPE.DANGER,
                  content: response.message!,
                });

                this.routingService.go('/my-account/quotes-history');
              }

              this.quoteDetails$.next(response);
            });
        }, 500);
      }
    });
  }

  handleActiveCart() {
    this.cartService.requireLoadedCart().subscribe();
  }
}
